import {appRouter} from '@netx/core-next/instance/router';
import {getUserLevel} from '@netx/core-user-next/utils/getUserLevel';
import coreConfig from '@netx/core-next/config';

/** @namespace */

export default {
	/**
	 * Blank route ('') corresponds to no route at all.
	 * The default behavior for the Netx url without a route is to show the top level category tree.
	 * @namespace
	 * @todo decouple?
	 * @todo HTML-582 - Duplicating boilerplate code on behalf of Nike Foundation.  Let's clean this up please.
	 * @fires module:app#category:route:top
	 * @listens module:app#auth:session:valid
	 */
	''() {
		if (getUserLevel() > 0) {
			// TODO: isValid() returns a promise & will always evaluate TRUE; not what we want.
			if (coreConfig.HOME_ROUTE) {
				appRouter.home();
			} else {
				dispatcher.trigger('category:route:top');
			}
		} else {
			/** @event */
			dispatcher.on('auth:session:valid', function () {
				if (coreConfig.HOME_ROUTE) {
					appRouter.home();
				} else {
					dispatcher.trigger('category:route:top');
				}
			});
		}
	},
	// External bundle
	'share/request(/:token)': () => window.location.reload(),
	'uploads/request(/:token)': () => window.location.reload(),
	// "*action":	function(action){
	// 	// !! IMPORTANT !!
	// 	// DEVNOTE: @spence - This is the default method that is run
	// 	// when there is no matching route pattern.  It is very important
	// 	// for proper functioning in certain situations where there may not
	// 	// be a valid session in play but we do have an access token.
	// 	// This route allows us to catch the route change and fire subsequent
	// 	// methods to identify and utilize the token value in the route.
	// }
};
